module.exports = __webpack_public_path__ + "cd455783/img/SOURCERY_poweredby_web.9819842b.png";